import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import { black_icons } from '../../icons';

function BalloonSelection({ showModal, onClose, modelOptions, fabricOptions, selectedFabric, setFabric, setModel, selectedModel, envelopeConfirmed, setEnvelopeConfirmed }) {
  const [selectedType, setSelectedType] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);

  const handleApply = () => {
    const newModel = modelOptions.items.find(item => item.name === selectedSize);

    if (newModel && newModel.data) {
      try {
        // Only trigger a full reset when the model actually changed — the fabric
        // dropdown already applies its own color-remapping live via onChange, so
        // re-applying the same model here would wipe canvasState for nothing.
        if (!selectedModel || newModel.id !== selectedModel.id) {
          setModel(newModel);
        }
        setEnvelopeConfirmed(true);
        if (onClose) {
          onClose();
        }

      } catch (error) {
        console.error("Error fetching model data:", error);
      }
    } else {
      console.error('Model data URL not found for selected model');
    }
  };


  const DropdownIndicator = (
    props
  ) => {
    return (
      <components.DropdownIndicator {...props}>
        <black_icons.rollIcon />
      </components.DropdownIndicator>
    );
  };
  const Placeholder = (props) => (
    <components.Placeholder {...props}>
      Choose
    </components.Placeholder>
  );

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      width: '100%',
      minHeight: '40px',
      fontSize: '18px'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: 'var(---ffffff-white)',
      color: state.isSelected ? 'var(--kb-500-0084cc)' : 'var(--k-900-303030)',
      ':hover': {
        backgroundColor: 'var(---ffffff-white)',
        color: 'var(---e6ab00-hover-color)'
      },
    }),
    menu: (provided, state) => ({
      ...provided,
      fontSize: '18px',
    }),
    menuPortal: (provided, state) => ({
      ...provided,
      zIndex: 15,
    })
  };

  useEffect(() => {
    if (selectedModel) {
      setSelectedType(selectedModel.type);
      setSelectedSize(selectedModel.name);
    } else if (modelOptions && modelOptions.types.default) {
      const defaultType = modelOptions.types.default;
      setSelectedType(defaultType);
      const firstModelInType = modelOptions.items.find(m => m.type === defaultType);
      if (firstModelInType) {
        setSelectedSize(firstModelInType.name);
      }
    }
  }, [selectedModel, modelOptions]);

  return (

    <div className="mdl backdrop-blur-[30px]" style={{ display: showModal ? 'flex' : 'none' }}>
      <div className="mdl-dia !max-w-5xl">
        <form>
          <div className="form-group">
            <label className='mdl-lbl'>Balloon model:</label>
            <div className='rad-btns'>
              {modelOptions && modelOptions.types.items.map((item) => (
                <button
                  key={item.id}
                  className={`rad-btn ${selectedType === item.id ? 'checked' : ''}`}
                  id={"typeSelection-" + item.id}
                  name="typeSelection"
                  value={item.id}
                  onClick={(e) => {
                    e.preventDefault();
                    (item.id !== selectedType) && setSelectedSize("Choose");
                    setSelectedType(item.id);
                    setSelectedSize(modelOptions.items.filter(m => m.type === item.id)[0].name);
                  }}
                >
                  {item.name}
                </button>
              ))}
            </div>
          </div>
          <div className='mdl-row balloon-selection-row'>
            {selectedType && <div className="form-group">
              <label className='mdl-lbl' htmlFor="sizeSelection">Size:</label>
              <Select
                inputId="sizeSelection"
                inputName="sizeSelection"
                value={selectedSize ? { value: selectedSize, label: modelOptions.items.find(item => item.name === selectedSize).code } : null}
                onChange={(selectedOption) => setSelectedSize(selectedOption.value)}
                options={modelOptions.items.filter(item => item.type === selectedType).map((item) => (
                  {
                    value: item.name,
                    label: item.code
                  }
                ))}
                className="basic-multi-select"
                classNamePrefix="select"
                components={{ DropdownIndicator, Placeholder }}
                styles={customStyles}
                menuPortalTarget={document.querySelector("body")}
              />
              {envelopeConfirmed && <p className="mdl-alert" style={{ fontSize: '16px', lineHeight: 1.25, marginTop: '12px' }}>Changing the balloon model will erase your current design.</p>}
            </div>}
            {fabricOptions && <div className="form-group">
              <label className='mdl-lbl' htmlFor="fabricSelection">Fabric:</label>
              <Select
                inputId="fabricSelection"
                inputName="fabricSelection"
                onChange={(selectedOption) => {
                  setFabric(selectedOption.value);
                }}
                value={selectedFabric ? { value: selectedFabric, label: selectedFabric.name } : null}
                options={fabricOptions.items.map((item) => (
                  {
                    value: item,
                    label: item.name
                  }))
                }
                className="basic-multi-select"
                classNamePrefix="select"
                components={{ DropdownIndicator, Placeholder }}
                styles={customStyles}
                menuPortalTarget={document.querySelector("body")}
              />
              {envelopeConfirmed && <p className="mdl-alert" style={{ fontSize: '16px', lineHeight: 1.25, marginTop: '12px' }}>Not all fabrics offer the same colors. Your design's colors will be converted automatically, but some may change if the exact shade isn't available.</p>}
            </div>}
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
            <p style={{ fontSize: '16px', color: 'white', margin: 0, textAlign: 'center' }}>
              Diagonal patterns needed? <a href="https://kubicekballoons.com/en/graphic-sheets/" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--kb-500-0084cc)', textDecoration: 'underline' }}>Please use our graphic sheets to think about the design.</a>
            </p>
          </div>
          <div className='mdl-row'>
            <button className="mdl-btn primary" type="button" onClick={handleApply} disabled={!selectedType || !selectedFabric || !selectedSize}>APPLY</button>
            <button className="mdl-btn secondary" type="button" onClick={onClose}>CANCEL</button>
          </div>
        </form>

      </div>
    </div>
  );
}

export default BalloonSelection;